export const setTabIndexes = (element: Element, index: number) => {
	const focusableElements: NodeListOf<HTMLButtonElement | HTMLAnchorElement> =
		element.querySelectorAll('a, button');

	focusableElements.forEach((focusableElement) => {
		focusableElement.tabIndex = index;
	});
};
